module.exports = __webpack_public_path__ + "img/new.433efc07.png";